
export const findPermission = (identifier, navData, searchBy = 'link') => {
    if (!identifier || !navData) return null;

    const searchKey = searchBy.toLowerCase();
    const normalizedIdentifier = identifier.toLowerCase().trim();

    // Recursive search function
    const searchInData = (data) => {
        for (let item of data) {
            // Match logic based on searchBy
            let isMatch = false;
            
            if (searchKey === 'link') {
                isMatch = item.link?.toLowerCase() === normalizedIdentifier;
            } else if (searchKey === 'label') {
                isMatch = item.label?.toLowerCase() === normalizedIdentifier;
            }

            if (isMatch) {
                return {
                    _id: item._id,
                    label: item.label,
                    display_name: item.display_name,
                    link: item.link,
                    icon: item.icon,
                    web: item.web,
                    mobile: item.mobile,
                    view: item.view,
                    create: item.create,
                    edit: item.edit,
                    delete: item.delete,
                    excel: item.excel,
                    pdf: item.pdf,
                    full_access: item.full_access,
                    more_permissions: item.more_permissions,
                    is_parent: item.is_parent,
                    parent_id: item.parent_id
                };
            }

            // Search in children
            if (item.childs && item.childs.length > 0) {
                const childResult = searchInData(item.childs);
                if (childResult) return childResult;
            }
        }
        return null;
    };

    return searchInData(navData);
};


export const hasPermission = (identifier, navData, permissionType = 'web', searchBy = 'link') => {
    const permission = findPermission(identifier, navData, searchBy);
    
    if (!permission) return false;
    
    // 0 = No access, 1 = Has access, 2 = Full access
    return permission[permissionType] == 1;
};


export const getAllPermissions = (identifier, navData, searchBy = 'link') => {
    const permission = findPermission(identifier, navData, searchBy);
    
    if (!permission) {
        return {
            hasAccess: false,
            canView: false,
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canExport: false
        };
    }

    return {
        hasAccess: permission.web == 1,
        canView: permission.view == 1,
        canCreate: permission.create == 1,
        canEdit: permission.edit == 1,
        canDelete: permission.delete == 1,
        canExport: permission.excel == 1 || permission.pdf == 1,
        raw: permission
    };
};


export const createPermissionMap = (navData) => {
    const map = {
        byLink: {},
        byLabel: {}
    };

    const addToMap = (item) => {
        const permObj = {
            web: item.web,
            mobile: item.mobile,
            view: item.view,
            create: item.create,
            edit: item.edit,
            delete: item.delete,
            excel: item.excel,
            pdf: item.pdf,
            _id: item._id,
            label: item.label,
            link: item.link
        };

        if (item.link) {
            map.byLink[item.link] = permObj;
        }
        if (item.label) {
            map.byLabel[item.label.toLowerCase()] = permObj;
        }

        // Process children
        if (item.childs && item.childs.length > 0) {
            item.childs.forEach(child => addToMap(child));
        }
    };

    navData.forEach(item => addToMap(item));
    return map;
};



// // . Link से Permission निकालें:
// import { findPermission, hasPermission, getAllPermissions } from './utils/permissionHelper';

// // Basic usage
// const permission = findPermission('/account/consignor', navigationData, 'link');
// console.log(permission.web); // 1 or 2 or 0

// // Check specific permission
// const canAccess = hasPermission('/account/consignor', navigationData, 'web', 'link');
// console.log(canAccess); // true/false

// // Get all permissions
// const allPerms = getAllPermissions('/account/consignor', navigationData, 'link');
// console.log(allPerms);
// // {
// //   hasAccess: true,
// //   canView: true,
// //   canCreate: true,
// //   canEdit: true,
// //   canDelete: true,
// //   canExport: false,
// //   raw: {...}
// // }

// // Label based search
// const permission = findPermission('Party', navigationData, 'label');
// console.log(permission.link); // '/account/consignor'

// const canAccess = hasPermission('LR', navigationData, 'web', 'label');
// console.log(canAccess); // true/false